import React from 'react';
import PropTypes from 'prop-types';
import Headline from '../../atoms/headline/headline';
import Copy from '../../atoms/copy/copy';
import Image from '../../atoms/image/image';
import Container from '../../layout/container/container';

import StyledExibitionIntro from './exhibitionIntro.style';

const imageSizes = [
  {
    condition: 'min-width: 980px',
    width: '1440px'
  },
  {
    condition: 'min-width: 450px',
    width: '100vw'
  },
  {
    width: '100vw'
  }
];

const ExhibitionIntro = ({ headline, copy, image }) => (
  <StyledExibitionIntro>
    <div className="exhibtionIntro__image">
      <div className="exhibitionIntro__image-wrapper">
        <Image {...image} sizes={imageSizes} />
      </div>
    </div>

    <Image
      className="exhibitionIntro__background"
      lazy="default"
      role="presentation"
      src="/static/dots/dots-neutral.png"
      srcset={[
        { src: '/static/dots/dots-neutral-2x.png', suffix: '2x' },
        { src: '/static/dots/dots-neutral.png', suffix: '1x' }
      ]}
      sizes={[
        {
          condition: 'min-width: 980px',
          width: '1440px'
        },
        {
          condition: 'min-width: 450px',
          width: '100vw'
        },
        {
          width: '100vw'
        }
      ]}
    />

    <Container>
      <div className="exhibitionIntro__text">
        <Headline className="exhibitionIntro__headline" primary>
          {headline}
        </Headline>
        <Copy className="exhibitionIntro__copy">{copy}</Copy>
      </div>
    </Container>
  </StyledExibitionIntro>
);

ExhibitionIntro.propTypes = {
  headline: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  image: PropTypes.shape().isRequired
};

export default ExhibitionIntro;
